import React from 'react';
import '../styles/Custom.css';
import Typography from './Typography';

const ListItem = ({
    text,
    onClick,
    disabled = false,
    variant = 'primary',
    item,
    className = '',
}) => {

    return (
        <li key={item.path} className={`${className} flex gap-3 items-center`} >
            {item.icon}
            <Typography color={'#FFF'} text={item.label} size={'14px'} family={'Supply'} weight={400} lineheight={'60px'} transform={'uppercase'} />
        </li>
    );
};

export default ListItem;